import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Heading, Stack, Text, TextLink } from '@origin-digital/ods-core';
import { findBusinessAccountForManualRegWithCaptcha } from 'ts/services/find-account/FindAccountService';
import { sendOtcAndRedirect } from './Actions';
import { Page } from 'ts/components/Page';
import { AuthCard } from 'ts/components/Card';
import { errorPageAction, getUserProvidedUsername } from './SharedUtils';
import { BusinessCustomerLookupForm } from './BusinessCustomerLookupForm';
import { ROUTES } from 'ts/Routes';

export const ManualRegBusinessCustomerLookupPage = () => {
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [alertBoxError, setAlertBoxError] = useState<string | undefined>(undefined);

  const handleSubmit = async (accountNumber: string, businessName: string, abn: string) => {
    setLoading(true);
    try {
      const response = await findBusinessAccountForManualRegWithCaptcha(
        accountNumber,
        businessName,
        abn,
      );
      await sendOtcAndRedirect(history, response.data.email, getUserProvidedUsername(location));
    } catch (error) {
      const status = error.response && error.response.status;
      if (status === 403 || status === 404) {
        setAlertBoxError(
          "Hmm, we can't find an account linked to those details. Please check and try again, or [contact us](LIVECHAT).",
        );
        setLoading(false);
      } else {
        errorPageAction(history)(error.response && error.response.status);
      }
    }
  };

  return (
    <Page>
      <AuthCard>
        <Stack>
          <Heading variant="h3">Let’s find your account details</Heading>
          <Text weight="regular">
            We can’t seem to find{' '}
            <Text weight="medium" inline>
              {getUserProvidedUsername(location)}
            </Text>{' '}
            in our system. Don’t worry, we just need a few extra details to get you into My Account.
            Or,{' '}
            <TextLink href="" onClick={() => history.push(ROUTES.MANUAL_REG_FIND_CUSTOMER)}>
              register as a residential customer
            </TextLink>
            .
          </Text>
          <BusinessCustomerLookupForm
            handleSubmit={handleSubmit}
            loading={loading}
            alertBoxError={alertBoxError}
            setAlertBoxError={setAlertBoxError}
          />
        </Stack>
      </AuthCard>
    </Page>
  );
};
